import { get, isEmpty, isNil } from "lodash";
import ApiImage from "./ApiImage";
import ApiAuthor from "./ApiAuthor";
import ContentfulStory from "models/data/contentful/ContentfulStory";
import ContentfulToApiStory from "models/data/mappings/ContentfulToApiStory";
import ApiTextEssay from "./ApiTextEssay";

class ApiStory {
  static default = {
    id: "",
    title: "",
    summary: "",
    featuredImage: ApiImage.default,
    author: ApiAuthor.default,
    authorMultiple: [ApiAuthor.default],
    publicationDate: "2019-01-01",
    textEssay: ApiTextEssay.default,
    categories: [],
  };

  static id = (apiStory) => get(apiStory, "id", ApiStory.default.id);

  static title = (apiStory) => get(apiStory, "title", ApiStory.default.title);

  static summary = (apiStory) =>
    get(apiStory, "summary", ApiStory.default.summary);

  static featuredImage = (apiStory) =>
    get(apiStory, "featuredImage", ApiStory.default.featuredImage);

  static featuredImageUrl = (apiStory) =>
    ApiImage.url(ApiStory.featuredImage(apiStory));

  static author = (apiStory) => get(apiStory, "author", ApiAuthor.default);

  static multipleAuthors = (apiStory) =>
    get(apiStory, "authorMultiple", ApiStory.default.authorMultiple);

  static authorFullName = (apiStory) =>
    ApiAuthor.fullName(ApiStory.author(apiStory));

  static publicationDate = (apiStory) =>
    get(apiStory, "publicationDate", ApiStory.default.publicationDate);

  static textEssay = (apiStory) =>
    get(apiStory, "textEssay", ApiStory.default.textEssay);

  static hasTextEssay = (apiStory) =>
    !isEmpty(ApiTextEssay.id(ApiStory.textEssay(apiStory)));

  static hasEssay = (apiStory) =>
    !isEmpty(ApiTextEssay.id(ApiStory.textEssay(apiStory)));

  static categories = (apiStory) =>
    get(apiStory, "categories", ApiStory.default.categories);

  static withPaywall = (apiStory) => {
    if (isNil(apiStory)) return ApiStory.default;
    return {
      ...apiStory,
      textEssay: ApiTextEssay.withPaywall(ApiStory.textEssay(apiStory)),
    };
  };

  static async fetch(storyId) {
    const contentfulStory = await ContentfulStory.fetch(storyId);
    const apiStory = await ContentfulToApiStory.map(contentfulStory);
    return apiStory;
  }
}

export default ApiStory;
